module.exports = __webpack_public_path__ + "img/arrow-down-active.3fda22a2.svg";